import { render, staticRenderFns } from "./ProgresoSubida.vue?vue&type=template&id=645b0496"
import script from "./ProgresoSubida.vue?vue&type=script&lang=js"
export * from "./ProgresoSubida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports